import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { getDefaultDateTime } from "../../utils/task";
var state = ["PROCESSED", "COMPLETE"];

var crons = ["0 0 14 1/1 * ? *", "0 0 12 ? * MON-FRI *", "0 0 5 ? 1/1 MON#1 *"];

var types = [
  { name: "Deploy Terraform", action: "start", category: "TERRAFORM" },
  { name: "Start All Instances", action: "start", category: "START" },
  { name: "Stop Dev Instances", action: "stop", category: "STOP" },
  {
    name: "Backup Instances",
    action: "backup",
    category: "BACKUP",
    scope: "14a6531d-9101-4c87-983b-146a89eabc5b",
  },
  {
    name: "Restore Instances",
    action: "restore",
    category: "RESTORE",
    scope: "14a6531d-9101-4c87-983b-146a89eabc5b",
  },
  {
    name: "Backup Instances",
    action: "backup",
    category: "BACKUP",
  },
  {
    name: "Restore Instances",
    action: "restore",
    category: "RESTORE",
  },
  {
    name: "Patch All Instances",
    action: "installPatch",
    category: "PATCH-INSTALL",
  },
  {
    name: "Patch Testing Instances",
    action: "installPatch",
    category: "PATCH-INSTALL",
  },
  { name: "Scan All Instances", action: "scanPatch", category: "PATCH-SCAN" },
  {
    name: "Scan Testing Instances",
    action: "scanPatch",
    category: "PATCH-SCAN",
  },
  {
    name: "Desired State Testing Instances",
    action: "executeDss",
    category: "DESIRED-SERVER-STATE",
  },
];

export const createSchedule = (data) => {
  let schedule = "";
  let payload = "";
  if (data && data.Schedule) {
    schedule = data.Schedule;
    payload = data.Accounts;
  }
  let selectedType = data.category ? data : faker.helpers.arrayElement(types);
  let selectedName = selectedType.name;
  var s = {
    Name: schedule.Name || selectedName,
    Description: schedule.Description || faker.random.words(2),
    IsRecurring: schedule.Cron ? true : faker.random.boolean(),
    Cron: schedule.Cron || "",
    LastExecutionStatus: faker.helpers.arrayElement(state),
    NextOccurrence: schedule.Cron ? faker.date.future() : "",
    ScheduleId: uuidv4(),
    ResourcePath: schedule.ResourcePath || "/compute/instance",
    Category: selectedType.category,
    Payload: payload || {
      Action: selectedType.action,
      Accounts: [
        {
          Regions: [
            {
              InstanceId: ["i-03749f25af50030fc"],
              RegionCode: "us-east-1",
            },
          ],
          AccountNumber: "846823036883",
        },
      ],
      Schedule: {
        Category: "EC2",
        Description: selectedType.description
          ? selectedType.description
          : selectedType.name,
        IsDisabled: false,
        ResourcePath: "/compute/instance",
        ExecuteAt: faker.date.past(),
        Name: selectedType.name
          ? selectedType.name
          : selectedType.category + " Codename: " + faker.random.word(),
      },
    },
    Disabled: false,
    Offset: "1555921459.0",
    LastUpdatedAt: "2019-04-22 08:25:12",
    CreatedBy: "15",
    ExecuteAt: schedule.ExecuteAt || faker.date.past(),
    CreatedAt: "2019-04-22 08:24:19",
  };

  if (data.scope) {
    s.Payload.ScopeId = "14a6531d-9101-4c87-983b-146a89eabc5b";
    s.IsRecurring = true;
  }

  return s;
};

export const allSchedules = () => {
  let schedules = [];
  types.forEach((type) => {
    var schedule = createSchedule(type);
    schedule.Description = `This is the schedule for ${schedule.Name}`;
    if (schedule.IsRecurring) {
      schedule.Cron = faker.helpers.arrayElement(crons);
      schedule.NextOccurrence = faker.date.future();
    }
    schedules.push(schedule);
  });

  return schedules;
};

export const createNewSchedule = (data) => {
  let newScheduledJob = {
    Name: data.Schedule.Name,
    Description: data.Schedule.Description,
    IsRecurring: data.Schedule.Cron ? true : false,
    Cron: data.Schedule.Cron,
    LastExecutionStatus: "",
    NextOccurrence: data.Schedule.ExecuteAt,
    ScheduleId: uuidv4(),
    ResourcePath: data.Schedule.ResourcePath,
    Category: data.Schedule.Category.toUpperCase(),
    Payload: {
      Action: data.Action,
      Accounts: [
        {
          Regions: [
            {
              InstanceId: data.ResourceIds,
              RegionCode: "us-east-1",
            },
          ],
          AccountNumber: "846823036883",
        },
      ],
      Schedule: data.Schedule,
    },
    Disabled: false,
    Offset: "1555921459.0",
    LastUpdatedAt: getDefaultDateTime,
    CreatedBy: "15",
    ExecuteAt: data.Schedule.ExecuteAt,
    CreatedAt: getDefaultDateTime(),
  };
  return newScheduledJob;
};
